import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const iv = {
    jpath: ['spectra', 'iv'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default iv;
//# sourceMappingURL=iv.js.map